import { Star } from 'lucide-react';

import { cn } from '@/lib/utils';

interface SignupRatingProps {
  className?: string;
  label?: string;
}

export function SignupRating({
  className,
  label = 'on Shopify App Store',
}: SignupRatingProps) {
  return (
    <div
      className={cn('inline-flex items-center gap-2 text-sm text-content-primary', className)}
      aria-label={`4.9 out of 5 ${label}`}
    >
      <span className="inline-flex items-center gap-1" aria-hidden="true">
        {Array.from({ length: 5 }).map((_, index) => (
          <Star key={index} className="h-3.5 w-3.5 text-amber-400" fill="currentColor" />
        ))}
      </span>
      <span className="font-semibold text-content-primary">4.9/5</span>
      <span>{label}</span>
    </div>
  );
}
